import { Model } from "@vuex-orm/core";
import Address from "./address";

export default class Notification extends Model {
  static entity = "notifications";

  static fields() {
    return {
      id: this.attr(null),
      enabled: this.attr(false),
      a_upper: this.attr(0),
      a_lower: this.attr(0),
      b_upper: this.attr(0),
      b_lower: this.attr(0),
      c_upper: this.attr(0),
      c_lower: this.attr(0),
      d_upper: this.attr(0),
      d_lower: this.attr(0),

      addresses: this.hasMany(Address, "notification_id"),
      measure_id: this.attr(null),
    };
  }
}
